const DEFAULT_REQUESTS_PATH = '/requests';

const readString = (...values) => {
  for (const value of values) {
    const normalized = String(value || '').trim();
    if (normalized) return normalized;
  }
  return '';
};

const readPositiveNumber = (...values) => {
  for (const value of values) {
    const parsed = Number(value);
    if (Number.isFinite(parsed) && parsed > 0) {
      return parsed;
    }
  }
  return 0;
};

const normalizePath = (value) => {
  const normalized = readString(value);
  if (!normalized) return '';
  return normalized.startsWith('/') ? normalized : `/${normalized}`;
};

export const resolveRequestPath = (item) => {
  const explicitPath = normalizePath(item?.link?.path);
  if (explicitPath) {
    return explicitPath;
  }

  const kind = readString(item?.kind, item?.link?.kind, item?.metadata?.kind).toLowerCase();
  const pdfId = readString(item?.pdf_id, item?.link?.pdf_id, item?.metadata?.pdf_id);
  const sectionNumber = readPositiveNumber(
    item?.section_number,
    item?.link?.section_number,
    item?.metadata?.section_number
  );

  if (!pdfId) {
    return DEFAULT_REQUESTS_PATH;
  }

  const shouldOpenSection =
    sectionNumber > 0
    || kind === 'test_case_approval'
    || kind === 'test_case_approval_outcome';

  if (shouldOpenSection && sectionNumber > 0) {
    return `/pdf/${encodeURIComponent(pdfId)}/sections/${sectionNumber}/save`;
  }

  return `/pdf/${encodeURIComponent(pdfId)}/sections`;
};
